module.exports = __webpack_public_path__ + "img/carousel-01.3fb13772.png";